import { Component, OnInit } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { AddConfigurationComponent } from 'src/app/components/configuration/components/widgets/add/configuraton.add.component';
import { ConfigurationGroupModel } from 'src/app/components/configuration/models/configurationGroupModel';
import { ConfigurationTypeModel } from 'src/app/components/configuration/models/configurationTypeModel';
import { ConfigurationModel } from 'src/app/components/configuration/models/configurationModel';
import { ConfigurationSearchModel } from 'src/app/components/configuration/models/configurationSearchModel';
import { CopyConfigurationComponent } from 'src/app/components/configuration/components/widgets/copy/configuraton.copy.component';
import { environment } from 'src/environments/environment';
import { RestAPIService } from 'src/app/services/restapi.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-configurationdetails',
    templateUrl: './configurationdetails.component.html'
})
export class ConfigurationDetailsComponent implements OnInit {
    public pageSize = 10;
    public currentPage = 0;
    public totalSize = 0;
    configurationGroupList: ConfigurationGroupModel[] = [];
    configurationTypeList: ConfigurationTypeModel[] = [];
    configurationList: ConfigurationModel[] = [];
    sortedConfigurationList: ConfigurationModel[] = [];
    configurationModel: ConfigurationModel = new ConfigurationModel();
    configurationSearchModel: ConfigurationSearchModel = new ConfigurationSearchModel();
    productCode: string | undefined;
    currentSort!: Sort;
    isAdvanceSearchFilter: boolean = false;

    displayedColumns = ['configKey','name','description','configurationTypeCode', 'action'];
    
    constructor(
        public _restAPI: RestAPIService,
        private route: ActivatedRoute, 
        private router: Router,
    private dialog: MatDialog) {
        this._restAPI.loading  = false;
    }
  
    async ngOnInit() {
        if (localStorage.getItem('reloadConfigurationSearchModel') === 'true' && localStorage['configurationSearchModel'] != null && localStorage['configurationSearchModel'].length > 0) {
            this.configurationSearchModel = JSON.parse(localStorage['configurationSearchModel']);
            this.isAdvanceSearchFilter = true;
            localStorage['reloadConfigurationSearchModel'] = '';
        }
        else {
            localStorage['configurationSearchModel'] = '';
            localStorage['reloadConfigurationSearchModel'] = '';
        }
        this.getQueryParams();
        await this.getConfigurationTypeList();
        await this.getConfigurationList();
        await this.getConfigurationGroupList();
    }

    //#region Get query params
    getQueryParams(): void {
        this.route
            .queryParams
            .subscribe(params => {
                // Defaults to 0 if no query param provided.
                let productCode = params['productCode'] as string;
                this.productCode = productCode || '';
                if (this.productCode === null || this.productCode.length <= 0) {
                    this.router.navigateByUrl('/configuration');
                }
            });
    }
    //#endregion

    openConfigurationDialog(configurationModel: ConfigurationModel): void {
        const dialogRef = this.dialog.open(AddConfigurationComponent, {
          width:"700px",
          height:"auto",
          data: {configuration: configurationModel, productCodeData: this.productCode}
        });
  
        dialogRef.afterClosed().subscribe((result: boolean) => {
            this.configurationModel = new ConfigurationModel();
            if (result) {
                this.getConfigurationList();
            }
        });
      }
  
    onDisplayFilter(e:any) {
        this.isAdvanceSearchFilter = !this.isAdvanceSearchFilter;
        if(e) {
            e.stopPropagation();
        }
    }

    async resetSearch() {
        this.configurationSearchModel = new ConfigurationSearchModel();
        this.getConfigurationList();
    }

    async getConfigurationGroupList() {
        this._restAPI.loading  = true;
        this._restAPI.get<ConfigurationGroupModel[]>(environment.apiURL + 'api/configuration/' + this.productCode + '/group').subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                this.configurationGroupList = data;
            },
            error: (error) => {console.error(error);this._restAPI.loading  = false;}
        });
    }
    
    async getConfigurationTypeList() {
        this._restAPI.loading  = true;
        this._restAPI.get<ConfigurationTypeModel[]>(environment.apiURL + 'api/configuration/' + this.productCode + '/type').subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                this.configurationTypeList = data;
            },
            error: (error) => {this._restAPI.loading  = false; console.error(error);}
        });
    }
    
    async getConfigurationList() {
        localStorage['configurationSearchModel'] = JSON.stringify(this.configurationSearchModel);
        this._restAPI.loading  = true;
        this._restAPI.post<ConfigurationModel[]>(environment.apiURL + 'api/configuration/' + this.productCode + '/search', this.configurationSearchModel).subscribe({
            next: (data) => {
                this._restAPI.loading  = false;
                this.configurationList = data ?? [];
                this.sortedConfigurationList = this.configurationList.slice();
                if (this.sortedConfigurationList != null && this.sortedConfigurationList.length > 0) {
                    for (const config of this.sortedConfigurationList) {
                        let item = this.configurationTypeList.find(i => i.code === config.configurationTypeCode);
                        if (item != null) {
                            config.configurationType = item.description;
                        }
                    }
                }
                this.totalSize = this.sortedConfigurationList.length;
                this.pageSize = 10;
                this.currentPage = 0;
                this.iterator();
            },
            error: (error) => {this._restAPI.loading  = false; console.error(error);}
        });
    }

    public handlePage(e: any) {
        this.currentPage = e.pageIndex;
        this.pageSize = e.pageSize;
        this.iterator();
    }

    sortConfiguration(sort: Sort) {
        this.currentSort = sort;
        this.pageSize = 10;
        this.currentPage = 0;
        this.sortConfigurationArray(this.configurationList.slice(), this.currentSort, 0, 10);
    }

    private iterator() {
        const end = (this.currentPage + 1) * this.pageSize;
        const start = this.currentPage * this.pageSize;
        this.sortConfigurationArray(this.configurationList.slice(), this.currentSort, start, end);
    }

    private sortConfigurationArray(configurations: ConfigurationModel[], sort: Sort, start: number, end: number): void {
        if (sort === undefined || !sort.active || sort.direction === '') {
            this.sortedConfigurationList = configurations.slice(start, end);
            return;
        }

        this.sortedConfigurationList = this.configurationList.sort((a: any, b: any) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'configKey': return compare(a.configKey, b.configKey, isAsc);
                case 'name': return compare(a.name, b.name, isAsc);
                case 'description': return compare(a.description, b.description, isAsc);
                case 'configurationType': return compare(a.configurationType, b.configurationType, isAsc);
                default: return 0;
            }
        });

        const part = this.sortedConfigurationList.slice(start, end);
        this.sortedConfigurationList = [];

        for (const item of part) {
            this.sortedConfigurationList.push(item);
        }
    }

    openCopyConfigurationDialog(configurationModel: ConfigurationModel): void {
        const dialogRef = this.dialog.open(CopyConfigurationComponent, {
          width:"700px",
          height:"auto",
          data: {configuration: configurationModel, productCodeData: this.productCode}
        });
  
        dialogRef.afterClosed().subscribe((result: any) => {
            this.configurationModel = new ConfigurationModel();
            if (result) {
                this.getConfigurationList();
            }
        });
    }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}